// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_MAIL = "GET_MAIL";
export const DELETE_MAIL = "DELETE_MAIL";